import React, { useState, useEffect, useCallback } from "react";
import { Redirect } from 'react-router';
import { FormOutlined, CheckOutlined, CloseOutlined, DeleteOutlined,EyeOutlined,RollbackOutlined ,UsergroupAddOutlined} from "@ant-design/icons";
import {
    Form,
    Input,
    InputNumber,
    Select,
    DatePicker,
    TimePicker,
    Checkbox,
    Radio,
    Table,
    Popconfirm,
    Button,
    Divider,
    Col
} from "antd";
import { Tooltip } from '@material-ui/core';
import moment from "moment";
import "./TablaRegistro.scss";


const FormItem = Form.Item;
const Option = Select.Option;
const RadioGroup = Radio.Group;

const EditableContext = React.createContext();

const EditableRow = ({ form, index, ...props }) => (
    <EditableContext.Provider value={form}>
        <tr {...props} />
    </EditableContext.Provider>
);

const EditableFormRow = Form.create()(EditableRow);

const getColumnSearchProps = dataIndex => ({
    filter: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
        <Input />
    )
});
////console.log("props tabla props", props)

let plColumns=[]; 

const generarColums = (p) => {
//console.log("cambio columna", p)
 plColumns = [
   //empresas
    {
        title: p===1? "Tipo de boleta": p===2 ? "Tipo de acta": p===3 && "Tipo de aplicador",
        dataIndex:"nombre" ,
        width: "150px",
        editable: true,
        render: (text, record) => {
            let splited = text.split("-")
            return splited[2] ?splited[2]:splited[1];
        }
    },
       
    {
        title: "Cantidad",
        dataIndex: "cantidad",
        width: "150px",
        editable: true,
        render: (text, record) => {
            return text.toLocaleString('en-US', { maximumFractionDigits: 3 });
        }
    },
    {
        title: p===1 || p===2 ? "Medida de seguridad": p===3 && "Característica",
        dataIndex: p===1 || p===2 ? "medidaSeguridad": p===3 && "caracteristica",
        width: "300px",
        editable:true,
        disabled: p===1 || p===2 ? false: p===3 && true,
        render: (text, record) => {
            //console.log("MEDIDAS CARCATERISTICAS-", text)
          let nombre;
          text==='1'|| text===1? nombre="Marca":text==='2'|| text===2 ? nombre="Impresión":nombre="";  
          //console.log("MEDIDAS CARCATERISTICAS1-", nombre)
          p===3? text=nombre:text=text;
          //console.log("MEDIDAS CARCATERISTICAS3-", text)
          return text;
            
        }
    },
  
    {
        title: "Descripción de la medida",
        dataIndex: "descripcion",
        width: "400px",
        editable: true
    },
    {
        title: "Resultado",
        dataIndex: "resultado",
        width: "150px",
        editable: true,
        render: (text, record) => {
            return text.toLocaleString('en-US', { maximumFractionDigits: 3 });
        }
    },
    {
        title: "Comentarios",
        dataIndex: "comentarios",
        width: "400px",
        editable: true
    }
];
}


function EditableCell(
    props,
    optionsTipoA,
    rowEditing,
    setRowEditing
) {
    const handleRangeNumber = (rule, value, callback) => {
        if (value && (value > rule.max || value < rule.min)) {
            callback(rule.message)
        }
        callback()
    }
    const dateFormat = "DD-MM-YYYY";
    const timeFormat = "HH:mm";
    const getInput = (record, dataIndex, title, getFieldDecorator, getFieldValue, setFieldsValue) => {
        ////console.log("datos de record", record);
       // record.conRegistroSemanal=true;
        ////console.log("datos de record", record);
        switch (props.inputType) {
            case "float":
                return (
                    <FormItem style={{ margin: 0 }}>
                        {getFieldDecorator(dataIndex, {
                            rules: [
                                {
                                    type: 'float',
                                    message: `Campo ${title} no válido.`,
                                },
                                {
                                    required: true,
                                    message: `Ingrese el campo ${title}.`,
                                }
                            ],
                            initialValue: record[dataIndex]
                        })(
                            <InputNumber
                                style={{ width: '100%' }}
                                min={0}
                                formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                parser={value => value.replace(/\$\s?|(,*)/g, '')}
                            />
                        )}
                    </FormItem>
                );
            case "integer":
                return (
                    <FormItem style={{ margin: 0 }}>
                        {getFieldDecorator(dataIndex, {
                            rules: [
                                {
                                    type: 'integer',
                                    message: `Campo ${title} no válido.`,
                                },
                                {
                                    required: true,
                                    message: `Ingrese el campo ${title}.`,
                                },
                            ],
                            initialValue: record[dataIndex]
                        })(
                            <InputNumber
                                style={{ width: '100%' }}
                                min={0}
                                formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                parser={value => value.replace(/\$\s?|(,*)/g, '')}
                                placeholder="Ingresa"
                            />
                        )}
                    </FormItem>
                );
            case "number":
                return (
                    <FormItem style={{ margin: 0 }}>
                        {getFieldDecorator(dataIndex, {
                            rules: [
                                {
                                    required: true,
                                    message: `Ingrese el campo ${title}.`,
                                }
                            ],
                            initialValue: record[dataIndex]
                        })(
                            <InputNumber formatter={value => value} parser={value => value} />
                        )}
                    </FormItem>
                );
            case "date":
                return (
                    <FormItem style={{ margin: 0 }}>
                        {getFieldDecorator(dataIndex, {
                            initialValue: moment(record[dataIndex], dateFormat)
                        })(<DatePicker format={dateFormat} />)}
                    </FormItem>
                );
            case "time":
                return (
                    <FormItem style={{ margin: 0 }}>
                        {getFieldDecorator(dataIndex, {
                            initialValue: moment(record[dataIndex], timeFormat)
                        })(<TimePicker format={timeFormat} />)}
                    </FormItem>
                );
            case "checkbox":
                return (
                    <FormItem style={{ margin: 0 }}>
                        {getFieldDecorator(dataIndex, {
                            initialValue: record[dataIndex] === "true",
                            valuePropName: "checked"
                        })(<Checkbox />)}
                    </FormItem>
                );

            case "radio":
                return (
                    <FormItem style={{ margin: 0 }}>
                        {getFieldDecorator(dataIndex, {
                            initialValue: record[dataIndex]
                        })(
                            <RadioGroup>
                                <Radio value={"a"}>a</Radio>
                                <Radio value={"b"}>b</Radio>
                            </RadioGroup>
                        )}
                    </FormItem>
                );
            case "select":
                return (
                    <FormItem style={{ margin: 0 }}>
                        {getFieldDecorator(dataIndex, {
                            initialValue: record[dataIndex]
                        })(
                            <Select style={{ width: 150 }}>
                                {[...Array(11).keys()]
                                    .filter(x => x > 0)
                                    .map(c => `Product ${c}`)
                                    .map((p, index) => (
                                        <Option value={p} key={index}>
                                            {p}
                                        </Option>
                                    ))}
                            </Select>
                        )}
                    </FormItem>
                );
            case "medidaSeguridad":
                return (
                    <Form.Item name="medidaSeguridad" style={{ margin: 0 }}>
                        {getFieldDecorator(dataIndex, {
                            //initialValue: record[dataIndex],
                            initialValue: rowEditing.medidaSeguridad,
                            rules: [
                                {
                                    required: true,
                                    message: `Ingrese el campo ${title}.`,
                                }
                            ],
                        })(
                            <Input
                                placeholder="Ingresa nombre la medida de seguridad"
                                //disabled={true}
                                maxLength={524}
                            />
                        )}
                    </Form.Item>
                )
                case "caracteristica":
                    return (
                        <Form.Item name="caracteristica" hasFeedback>
                        {getFieldDecorator('caracteristica', {
                            initialValue:rowEditing.caracteristica,
                        })(
                <Col span={20}>           
                            <Radio.Group name="radiogroup"
                defaultValue={rowEditing.caracteristica}
                disabled={true}
                >
                <Radio value={1} disabled={true}>Marca</Radio>
                <Radio value={2} disabled={true}>Impresión</Radio>
            </Radio.Group></Col>
                        )}
                    </Form.Item>
                    )
            case "nombre":
                return (
                    <FormItem name="nombre" style={{ margin: 0 }}>
                        {getFieldDecorator(dataIndex, {
                            //initialValue: record[dataIndex]
                            initialValue: rowEditing.nombre,
                        })(
                            <Select
                                style={{ width: '100%' }}
                               
                            >
                                {optionsTipoA.map((value, index) => {
                                    let splited=value.split("-")
                                    return <Select.Option key={value}>{splited[2] ?splited[2]:splited[1]}</Select.Option>;
                                })}
                            </Select>
                        )}
                    </FormItem>
                );
            case "fechaAdjudicacion":
                return (
                    <FormItem name="fechaAdjudicacion" style={{ margin: 0 }}>
                        {getFieldDecorator(dataIndex, {
                            //initialValue: moment(record[dataIndex], dateFormat)
                            initialValue: moment(rowEditing.fechaAdjudicacion, dateFormat),
                            rules: [
                                {
                                    required: true,
                                    message: 'Seleccione una fecha de adjudicación.',
                                }
                            ],
                        })
                            (
                                <DatePicker
                                    format={dateFormat}
                                    disabled={record.conRegistroSemanal}
                                    disabledDate={current => {
                                        return current.startOf('day') > moment().endOf('day')
                                    }}
                                    onChange={value => {
                                        if (value !== null) {
                                            if (getFieldValue('fechaInicioProduccion') !== null && getFieldValue('fechaInicioProduccion') !== undefined
                                                && value.startOf('day') > getFieldValue('fechaInicioProduccion').endOf('day')) {
                                                setFieldsValue({
                                                    fechaInicioProduccion: null,
                                                    fechaFinProduccion: null,
                                                })
                                            }
                                        }
                                        else {
                                            setFieldsValue({
                                                fechaInicioProduccion: null,
                                                fechaFinProduccion: null,
                                            })
                                        }
                                    }}
                                />
                            )}
                    </FormItem>
                );
            case "resultado":
                return (
                    <Form.Item name="resultado" style={{ margin: 0 }}>
                        {getFieldDecorator(dataIndex, {
                            rules: [
                                {
                                    type: 'number',
                                    message: `Campo ${title} no válido.`,
                                },
                                {
                                    required: true,
                                    message: `Ingrese el campo ${title}.`,
                                },
                                {
                                    validator: handleRangeNumber,
                                    message: 'Canitdad fuera del rango permitido.',
                                    min: 1,
                                    max: 100
                                }
                            ],
                            //initialValue: record[dataIndex]
                            initialValue: rowEditing.resultado
                        })(
                            <InputNumber
                                style={{ width: '100%' }}
                                disabled={record.conRegistroSemanal}
                                min={1}
                                max={100}
                                formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                parser={value => value.replace(/\$\s?|(,*)/g, '')}
                              
                              
                            />
                        )}
                    </Form.Item>
                );
            case "cantidad":
                return (
                    <Form.Item name="cantidad" style={{ margin: 0 }}>
                        {getFieldDecorator(dataIndex, {
                            rules: [
                                {
                                    type: 'integer',
                                    message: `Campo ${title} no válido.`,
                                },
                                {
                                    required: true,
                                    message: `Ingrese el campo ${title}.`,
                                },
                                {
                                    validator: handleRangeNumber,
                                    message: 'Canitdad fuera del rango permitido.',
                                    min: 1,
                                    max: 999
                                }
                            ],
                            //initialValue: record[dataIndex]
                            initialValue: rowEditing.cantidad
                        })(
                            <InputNumber
                                style={{ width: '100%' }}
                                min={1}
                                max={999}
                                formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                parser={value => value.replace(/\$\s?|(,*)/g, '')}
                                
                            />
                        )}
                    </Form.Item>
                );
            case "total":
                return (
                    <Form.Item name="total" style={{ margin: 0 }}>
                        {getFieldDecorator(dataIndex, {
                            rules: [
                                {
                                    type: 'number',
                                    message: `Campo ${title} no válido.`,
                                },
                                {
                                    required: true,
                                    message: `Ingrese el campo ${title}.`,
                                },
                                {
                                    validator: handleRangeNumber,
                                    message: 'Canitdad fuera del rango permitido.',
                                    min: 0.001,
                                    max: 999999999.999
                                }
                            ],
                            //initialValue: record[dataIndex]
                            initialValue: rowEditing.total
                        })(
                            <InputNumber
                                style={{ width: '100%' }}
                                min={0.001}
                                max={999999999.999}
                                disabled={true}
                                formatter={value => `$${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                parser={value => value.replace(/\$\s?|(,*)/g, '')}
                                precision={3}
                            />
                        )}
                    </Form.Item>
                );
            case "comentarios":
                return (
                    <Form.Item name="comentarios" style={{ margin: 0 }}>
                        {getFieldDecorator(dataIndex, {
                            //initialValue: record[dataIndex]
                            initialValue: rowEditing.comentarios
                        })(
                            <Input.TextArea
                                placeholder="Ingresa"
                                rows={2}
                                autoSize={{ minRows: 2, maxRows: 2 }}
                                allowClear={true}
                                maxLength={1500}
                            />
                        )}
                    </Form.Item>
                );
                case "descripcion":
                return (
                    <Form.Item name="descripcion" style={{ margin: 0 }}>
                        {getFieldDecorator(dataIndex, {
                            //initialValue: record[dataIndex]
                            initialValue: rowEditing.descripcion
                        })(
                            <Input.TextArea
                                placeholder="Ingresa"
                                rows={2}
                                autoSize={{ minRows: 2, maxRows: 2 }}
                                allowClear={true}
                                maxLength={1500}
                            />
                        )}
                    </Form.Item>
                );
            
            default:
                return (
                    <FormItem style={{ margin: 0 }}>
                        {getFieldDecorator(dataIndex, {
                            rules: [
                                {
                                    required: true,
                                    message: `Ingrese el campo ${title}.`,
                                }
                            ],
                            initialValue: record[dataIndex]
                        })(<Input />)}
                    </FormItem>
                );
        }
    };

    const {
        editing,
        dataIndex,
        title,
        inputType,
        record,
        index,
        ...restProps
    } = props;

    

     
    
   

   
    return (
       
        <EditableContext.Consumer>
            {form => {
             
                const { getFieldDecorator, getFieldValue, setFieldsValue } = form;
                return (
                    <td {...restProps}>
                        {editing
                            ?
                            getInput(record, dataIndex, title, getFieldDecorator, getFieldValue, setFieldsValue)
                            : restProps.children}
                    </td>
                );
            }}
        </EditableContext.Consumer>
    );
}

export default function TablaRegistroArticulo(props) {
////console.log("TABLA", props.data.length)
    const [tableData, setTableData] = useState({
        data: [],
        loadingData: false,
        editingKey: ""
    });
 


    const dateFormat = "DD-MM-YYYY";
    const timeFormat = "HH:mm";

    const [redirect, setRedirect] = useState({
        redirecting: false,
        url: "",
        idArticulo: -1,
        idTipoDocumentacion: -1,
        nombreArticulo: "",
        nombreEmpresa: "",
        fecha: "",
        tipo: "",
        montos:""
    });

    const renderRedirect = () => {
        if (redirect.redirecting) {
            return <Redirect to={{
                pathname: redirect.url,
                state: {
                    idArticulo: redirect.idArticulo,
                    idTipoDocumentacion: redirect.idTipoDocumentacion,
                    nombreArticulo: redirect.nombreArticulo,
                    nombreEmpresa: redirect.nombreEmpresa,
                    fecha:redirect.fecha,
                    tipo:redirect.tipo,
                    montos:redirect.montos
                }
            }

            } />
            ////console.log("redirect1", redirect);
        }
    }
 
    
    const columns = [
        ...plColumns,
        {
            title: "Acciones",
            width: "175px",
            align: "center",
            dataIndex: "operation",
            render: (text, record) => {
                const editable = isEditing(record);
                //console.log("Record1",record)
                return (
                    <div>
                        {editable ? (
                            <div>
                                <EditableContext.Consumer>
                                    {form => (
                                        <Tooltip title="Aceptar">
                                            <Button
                                                className="boton-edicion-confirmar"
                                                type="primary"
                                                shape="circle"
                                                accept=""
                                                disabled={!props.enableCaptura}
                                                onClick={() => save(form, record.key)}
                                            >
                                                <CheckOutlined />
                                            </Button>
                                        </Tooltip>
                                    )}
                                </EditableContext.Consumer>
                                < Divider className="dcolor" type="vertical" />
                                <Popconfirm
                                    title="¿Está seguro que desea Cancelar?"
                                    okText="Sí" cancelText="No"
                                    onConfirm={() => cancel(record.key)}
                                >
                                    <Tooltip title="Eliminar">
                                        <Button
                                            className="boton-edicion-cancelar"
                                            type="primary"
                                            shape="circle"
                                            accept=""
                                        >
                                            <CloseOutlined />
                                        </Button>
                                    </Tooltip>
                                </Popconfirm>
                            </div>
                        ) : (
                                <div>
                                     
                                    {props.enableEdit !== undefined && props.enableEdit ? (
                                        <Tooltip title="Modificar">
                                            <Button
                                                className="boton-accion-circular"
                                                type="primary"
                                                shape="circle"
                                                accept=""
                                                disabled={!props.enableCaptura}
                                                onClick={() => {
                                                    setRowEditing({
                                                        medidaSeguridad: record.medidaSeguridad,
                                                        caracteristica:record.caracteristica,
                                                        nombre: record.nombre,
                                                        fechaAdjudicacion: record.fechaAdjudicacion,
                                                        resultado: record.resultado,
                                                        cantidad: record.cantidad,
                                                        total: record.total,
                                                        comentarios: record.comentarios,
                                                        descripcion: record.descripcion,
                                                        fechaInicioProduccion: record.fechaInicioProduccion,
                                                        fechaFinProduccion: record.fechaFinProduccion,
                                                    });
                                                    edit(record.key);
                                                }}
                                            >
                                                <FormOutlined />
                                            </Button>
                                        </Tooltip>
                                    ) : null}
                                    {//props.enableEdit !== undefined && props.enableEdit &&
                                       // props.enableDelete !== undefined && props.enableDelete && !record.conRegistroSemanal &&
                                        //props.data.length > 1 ? (
                                            < Divider className="dcolor" type="vertical" />
                                        //) : null
                                    }
                                    {//props.enableDelete !== undefined && props.enableDelete && !record.conRegistroSemanal &&
                                    //props.data.length > 1 ? (
                                        <Popconfirm
                                            title="¿Está seguro que desea eliminar este artículo?"
                                            okText="Sí" cancelText="No"
                                            onConfirm={() => remove(record.key)}
                                        >
                                        <Tooltip title={"Eliminar" }>
                                                <Button
                                                    className="boton-accion-circular"
                                                    type="primary"
                                                    shape="circle"
                                                    accept=""
                                                    disabled={!props.enableCaptura}
                                                   /* style = {
                                                        {
                                                            transform: "translateY(13.1%)",
                                                            
                                                            backgroundImage: `url(${logoAyuda})`,
                                                            backgroundRepeat: "no-repeat",
                                                            borderStyle: 'none',
                                                            backgroundColor:'transparent',
                                                            boxShadow:'none',
        
                                                           height:'30px',
                                                           width:'64px',
            
                        
                                                        }
                                                    }*/

                                                >
                                                     <DeleteOutlined/>
                                                </Button>
                                            </Tooltip> </Popconfirm>
                                    //) : null
                                }
                                {//console.log("record11", record.caracteristica)
                                }
                                {//props.enableEdit !== undefined && props.enableEdit &&
                                       // props.enableDelete !== undefined && props.enableDelete && !record.conRegistroSemanal &&
                                        //props.data.length > 1 ? (
                                            record.caracteristica === 1 || record.caracteristica ==='1' ?
                                        <>    < Divider className="dcolor" type="vertical" />

                                        <Tooltip title="Modificar participantes">
                                        <Button
                                            className="boton-accion-circular"
                                            type="primary"
                                            shape="circle"
                                            accept=""
                                            disabled={!props.enableCaptura}
                                            onClick={() => modificar(record)}
                                        >
                                            <UsergroupAddOutlined />
                                        </Button>
                                    </Tooltip></>
                                    :""}
                                  
                                  
                                </div>
                            )}
                    </div>
                );
            }
        }
    ];

    const isEditing = record => {
        return record.key === tableData.editingKey;
    };

    function edit(key) {
        setTableData({
            editingKey: key,
            loadingData: true,
            data: tableData.data
        })
    }

    function remove(key) {
        if (!props.enableModificar)
            return true;
        const newData = [...tableData.data];
        const index = newData.findIndex(item => key === item.key);
        let rowRemove = newData.splice(index, 1);
        props.handleRemoveArt(newData, rowRemove);
        ////console.log("Remove", newData, rowRemove)

    }

    function save(form, key) {
        //console.log("save", form, key)
        if (!props.enableModificar)
            return true;
        form.validateFields((error, row) => {
            if (error) {
                return;
            }
            const newData = [...tableData.data];
            const index = newData.findIndex(item => key === item.key);
            if (index > -1) {
                const item = newData[index];
                
                props.handleSaveData(item, index, row);
            }
        });
    }

    function modificar(newData)
    {
        props.handleModificarData(newData)
    }
    const cancel = () => {
        setTableData({
            editingKey: "",
            loadingData: true,
            data: tableData.data
        })
    };

    const [rowEditing, setRowEditing] = useState({
        medidaSeguridad: null,
        caracteristica: null,
        nombre: null,
        fechaAdjudicacion: null,
        resultado: null,
        cantidad: null,
        total: null,
        comentarios: null,
        descripcion:null,
        fechaInicioProduccion: null,
        fechaFinProduccion: null,
    });

    const components = {
        body: {
            row: EditableFormRow,
            //cell: EditableCell
            cell: (cellProps) => {
                return EditableCell(
                    cellProps,
                    props.optionsTipoA,
                    rowEditing,
                    setRowEditing
                );
            },
        }
    };

    const columnsMap = columns.map(col => {
        if (!col.editable) {
            return col;
        }
        return {
            ...col,
            onCell: record => {
                const checkInput = index => {
                    switch (index) {
                        case "medidaSeguridad":
                            return "medidaSeguridad";
                        case "nombre":
                            return "nombre";
                        case "caracteristica":
                            return "caracteristica";
                        case "resultado":
                            return "resultado";
                        case "cantidad":
                            return "cantidad";
                       case "comentarios":
                            return "comentarios";
                            case "descripcion":
                            return "descripcion";
                        default:
                            return "text";
                    }
                };
                return {
                    record,
                    // inputType: col.dataIndex === "age" ? "number" : "text",
                    inputType: checkInput(col.dataIndex),
                    dataIndex: col.dataIndex,
                    title: col.title,
                    editing: isEditing(record)
                };
            }
        };
    });

    useEffect(() => {
        setTableData({
            data: props.data,
            loadingData: true,
            editingKey: ""
        });
       ////console.log ("Data tabla", tableData);
    }, [props.data]);

    // //console.log(tableData.data);
    return (
        <div>
            {////console.log("props table", props),
            renderRedirect()}
            { generarColums(props.opcion)}
            
        <Table
            className="tabla-adjudicaciones"
            components={components}
            bordered
            dataSource={tableData.data}
            columns={
                (props.enableEdit !== undefined && props.enableEdit || props.enableDelete !== undefined && props.enableDelete) ?
                    columnsMap : plColumns
            }
            scroll={{ x: 240 }}
            rowClassName="editable-row"
        /></div>
    );
}